import { ClassManager } from '../utils/classManager';
export var scaleManager = new ClassManager();
/**
 * default scale class
 */
var Scale = /** @class */ (function () {
    function Scale() {
    }
    Scale.prototype.setFormatter = function (formatter) {
        this.formatter = formatter;
    };
    return Scale;
}());
export default Scale;
